import React from 'react'
import Layout from '../Layout'
import HomeContent from '../components/HomeContent'
import styled from 'styled-components'

import bg from '../assets/images/zig_zag_wool.png'
//import Intro from '../sections/Intro'

const ComingSoon = styled.div`
  position: fixed;
  width: 100%;
  height: 100vh;
  background-image: url(${bg});
  background-repeat: repeat;
`
const LogoWrapper = styled.div`
  width: 100px;
  height: 100px;
  position: absolute;
  left: calc(50% - 50px);
  top: calc(50% - 50px);
`

const IndexPage = ({ data }) => {
  return (
      <Layout>
        <HomeContent data={data}/>
        {/*
      <ComingSoon>
        <LogoWrapper><SVG src={SvgLogo} /></LogoWrapper>
      </ComingSoon>
      */}
      </Layout>
  )
}

export const pageQuery = graphql`
  query IndexQuery {
    allStrapiHeroImages {
      edges {
        node {
          image {
            childImageSharp {
              original {
                src
              }
            }
          }
        }
      }
    }
    allStrapiPromotions(
      limit: 12
      sort: { fields: startDate, order: DESC }
      filter: { mainPage: { eq: true } }
    ) {
      edges {
        node {
          id
          name
          poster {
            childImageSharp {
              fluid {
                src
              }
            }
          }
          startDate
          endDate
          restaurants {
            Name
          }
        }
      }
    }
    allStrapiRestaurants(filter: {published: {eq: true}}, sort: {fields: Order, order: ASC}) {
      edges {
        node {
          id
          Order
          slug
          published
          Name
          slogan
          shortDescription
          description
          lat
          lng
          Address
          facebook
          instagram
          bookingsId
          frequentDiner
          asiaMiles
          cuisine {
            Name
          }
          type {
            Name
          }
          location {
            Name
          }
          logo {
            absolutePath
            relativePath
            base
            name
            extension
            childImageSharp {
              fluid {
                src
              }
            }
          }
        }
      }
    }
  }
`

export default IndexPage
